import { dateFormatter2 as dateFormatter, DateFormatTypes } from '@jfs/utils'
import {
  getDateTimeStampInMillis,
  getFrequency,
  getStatusFromMap,
  getType,
  dateFormatter as NewDateFormatter,
  DateFormatTypes as NewDateFormatterType,
  numberToLocalString,
} from '../../../util/util'

const transactionFilterTableParser = (data: any, fieldSetting: any[] = [], headerData: any) => {
  const header = JSON.parse(JSON.stringify({ ...headerData }))
  // const header = fieldSetting?.reduce((previous, item) => {
  //   return { ...previous, [item.id]: item.title }
  // }, {})
  let filterdTitle = []
  fieldSetting?.forEach((element: any) => {
    Object.entries(header).forEach(([key, value]) => {
      if (value === element.title && !element.isChecked) {
        delete header[key]
        filterdTitle.push(key)
      }
    })
  })

  Object.entries(header).forEach(([key, value]) => {
    let keyMatched = false
    fieldSetting.map((item: any) => {
      if (value === item.title) {
        keyMatched = true
      }
    })
    if (!keyMatched && key !== 'id') {
      delete header[key]
      filterdTitle.push(key)
    }
  })
  const body = data.map((item: any) => {
    return {
      id: item?.id ?? '',
      date: item?.date?.split('*')[0] ?? '', //Spliting as stored both formats needed for UI and for API
      ERN: item?.ern ?? '',
      RRN: item?.rrn ?? '',
      totalAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.amount) ?? 0}`,
      transactionStatus: item?.status,
      paymentMode: item?.payment?.paymentMode,
      paymentType: item?.payment?.paymentType,
      bankRefNo: item?.bankRefNumber,
      transactionType: item?.type,
      settlementRefNo: item?.settlementDetails?.referenceNumber,
      accountNumber: item?.payment?.accountNumber,
      refundAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.refund?.amount) ?? 0}`,
      authCode: item?.authCode,
      acquirerTerminal: item?.acquirerTerminal,
      surCharge: `${'\u20B9'}${' '}${item?.surCharge ?? 0}`,
      // convenienceFeeAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.convenienceFeeAmount) ?? 0}`, // Commented as per request from Santosh and Sujit to remove from FE
      // emiCode: item?.emiCode,// Commented as per request from Santosh and Sujit to remove from FE
      merchantName: item?.merchantName,
      merchantType: item?.merchantType,
      settlementStatus: item?.settlementDetails?.status,
      settledAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.settlementDetails?.settledAmount) ?? 0}`,
      // chargeBackReason: item?.disputes?.chargeBackReasonCode,// Commented as per request from Santosh and Sujit to remove from FE
      refundStatus: item?.refund?.status,
      settlementDate: item?.settlementDetails?.date ?? '',
      customerId: item?.customer?.id,
      customerName: item?.customer?.name,
      mobileNumber: item?.customer?.mobileNumber,
      email: item?.customer?.email,
      offerTransactionAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.offer?.offerTransactionAmount)}`,
      cashBackAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.offer?.cashBackAmount)}`,
      instantDiscountAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.offer?.instantDiscountAmount)}`,
      offerCode: item?.offer?.offerCode,
      offerReferenceId: item?.offer?.offerReferenceId,
      convenienceFee: `${'\u20B9'}${' '}${numberToLocalString(item?.convenienceFee?.amount)}`,
      originalTxnAmt: `${'\u20B9'}${' '}${numberToLocalString(item?.convenienceFee?.originalTxnAmt)}`,
      ugst: `${'\u20B9'}${' '}${numberToLocalString(item?.convenienceFee?.ugst)}`,
      igst: `${'\u20B9'}${' '}${numberToLocalString(item?.convenienceFee?.igst)}`,
      cgst: `${'\u20B9'}${' '}${numberToLocalString(item?.convenienceFee?.cgst)}`,
      sgst: `${'\u20B9'}${' '}${numberToLocalString(item?.convenienceFee?.sgst)}`,
      failureReason: item?.failureReason ?? 'NA',
    }
  })

  body.forEach((element: any) => {
    Object.keys(element).forEach((key: any) => {
      if (filterdTitle.includes(key)) {
        delete element[key]
      }
    })
  })

  return [header, ...body]
}

export const transactionFilterTableParserNew = (data: any, fieldSettings: any[] = [], isSPlitEnabled?: boolean) => {
  let allFieldSettings = fieldSettings
  // if (isSPlitEnabled) {
  //   allFieldSettings = [...fieldSettings, { id: 'splitRefundAction', isChecked: true, title: 'Action', isDisable: false }]
  // }
  const checkedFieldItem = allFieldSettings
    .filter((fieldSetting: any) => fieldSetting.isChecked)
    .reduce((result, current) => {
      result[current.id] = current.title
      return result
    }, {})
  let updatedFieldItems = isSPlitEnabled
    ? {
        ...checkedFieldItem,
        refundAmount: '',
      }
    : checkedFieldItem
  const filteredData = data.map((transactionMap: any) => {
    const formattedData = Object.keys(updatedFieldItems).reduce((result: any, key) => {
      result[key] =
        key === 'transactionAmount'
          ? `${'\u20B9'}${' '}${numberToLocalString(transactionMap.get(key)) ?? 0}`
          : transactionMap.get(key)

      return result
    }, {})
    if (!formattedData.id) {
      formattedData.id = transactionMap.get('originalTransactionId')
    }
    if (Object.keys(checkedFieldItem).includes('refundChannel')) {
      formattedData.refundChannel = transactionMap?.get('refundChannel')?.get('refundMode')
      formattedData.initiatorName = transactionMap?.get('refundChannel')?.get('initiatorName')
      formattedData.initiatorMobileNo = transactionMap?.get('refundChannel')?.get('initiatorMobileNo')
    }

    formattedData.splitRefundAction = 'NA'
    return formattedData
  })
  return [checkedFieldItem, ...filteredData]
}

const transactionFilterMobileTableParser = (data: any) => {
  const parsedData = JSON.parse(JSON.stringify(data))
  const body = parsedData?.map((item: any) => {
    const dataCopy: any = {
      id: item?.id ?? '',
      date: item?.date?.split('*')[0] ?? '', //Spliting as storing both formats needed for UI with index 0 and for API at index 1
      ERN: item?.ern ?? '',
      RRN: item?.rrn ?? '',
      totalAmount: `${'\u20B9'}${''}${numberToLocalString(item?.amount) ?? 0}`,
      transactionStatus: item?.status,
      paymentMode: item?.payment?.paymentMode,
      paymentType: item?.payment?.paymentType,
      bankRefNo: item?.bankRefNumber,
      transactionType: item?.type,
      settlementRefNo: item?.settlementDetails?.referenceNumber,
      accountNumber: item?.payment?.accountNumber,
      refundAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.refund?.amount) ?? 0}`,
      authCode: item?.authCode,
      acquirerTerminal: item?.acquirerTerminal,
      surCharge: `${'\u20B9'}${' '}${item?.surCharge ?? 0}`,
      convenienceFeeAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.convenienceFeeAmount) ?? 0}`,
      emiCode: item?.emiCode,
      merchantName: item?.merchantName,
      merchantType: item?.merchantType,
      settlementStatus: item?.settlementDetails?.status,
      settledAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.settlementDetails?.settledAmount) ?? 0}`,
      chargeBackReason: item?.disputes?.chargeBackReasonCode,
      refundStatus: item?.refund?.status,
      settlementDate: item?.settlementDetails?.date ?? '',
      customerId: item?.customer?.id,
      customerName: item?.customer?.name,
      mobileNumber: item?.customer?.mobileNumber,
      email: item?.customer?.email,
      timestamp: item?.timestamp,
    }
    return dataCopy
  })
  return [...body]
}

const subscriptionfilterTableParserData = (data: any, fieldSetting: any, headerData: any) => {
  const header = JSON.parse(JSON.stringify({ ...headerData }))
  let filterdTitle = []
  fieldSetting?.forEach((element: any) => {
    Object.entries(header).forEach(([key, value]) => {
      if (value === element.title && !element.isChecked) {
        delete header[key]
        filterdTitle.push(key)
      }
    })
  })
  const paymentModeMap = {
    '589': 'UPI',
    '590': 'Cards',
  }

  const body = data.map((item: any) => {
    return {
      id: item?.id ?? '',
      subscriptionId: item?.invoice ?? '',
      customerId: item?.customer?.externalId ?? '',
      amount: `${'\u20B9'}${' '}${numberToLocalString(item?.amount) ?? 0}`,
      type: getType[item?.type ?? ''],
      frequency: getFrequency[item?.frequency ?? ''],
      paymentMode: paymentModeMap[item?.paymentMode as keyof typeof paymentModeMap] ?? 'NA',
      startDate: dateFormatter(item?.scheduledAt, DateFormatTypes.MONTH_STRING_ISO),
      endDate: dateFormatter(item?.scheduledEnd, DateFormatTypes.MONTH_STRING_ISO),
      status: item?.status ?? '',
      customerName: item?.customer?.name ?? '',
      email: item?.customer?.email ?? '',
      mobileNumber: item?.customer?.mobile ?? '',
      createdAt: dateFormatter(item?.createdAt, DateFormatTypes.MONTH_STRING_ISO) ?? '',
      updatedAt: dateFormatter(item?.updatedAt, DateFormatTypes.MONTH_STRING_ISO) ?? '',
      revocable: item?.revocable?.toString() ?? 'false',
      rrv: item?.ruleRecurrenceValue ?? 0,
      jsi: item?.jmSubsId ?? '',
    }
  })

  body.forEach((element: any) => {
    Object.keys(element).forEach((key: any) => {
      if (filterdTitle.includes(key)) {
        delete element[key]
      }
    })
  })
  return [header, ...body]
}

const transactionRecentsTableParse = (data: any) => {
  return data.map((item: any) => ({
    id: item?.get('transactionId') ?? '',
    ERN: item?.get('invoice') ?? '',
    date: item?.get('transactionDateTime')?.split('*')[0] ?? '',
    RRN: item?.get('transactionId') ?? '',
    totalAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.get('transactionAmount')) ?? 0}`,
    transactionStatus: item?.get('transactionDisposition'),
    paymentMode: item?.get('cardType'),
  }))
}

const refundMobileTableParser = (data: any) => {
  return data.map((item: any) => ({
    id: item?.id ?? 'NA',
    originalTransactionId: item?.originalTransactionId ?? '',
    date: item?.date?.split('*')[0] ?? 'NA', //Spliting as storing both formats needed for UI with index 0 and for API at index 1
    ERN: item?.ern ?? 'NA',
    totalAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.amount) ?? 0}`,
    refundAmount: `${'\u20B9'}${''}${numberToLocalString(item?.refund?.amount) ?? 0}`,
    refundRequestDate: item?.refund?.requestedDate,
    refundProcessedDate: item?.refund?.processdDate,
    refundStatus: item?.refund?.status,
    RRN: item?.rrn ?? '',
    paymentMode: item?.payment?.paymentMode,
    customerName: item?.customer?.name,
    timestamp: item?.timestamp,
  }))
}

const refundsRecentsTableParser = (data: any) => {
  return data.map((item: any) => ({
    id: item?.get('originalTransactionId') ?? 'NA',
    ERN: item?.get('invoice') ?? 'NA',
    date: item?.get('transactionDateTime')?.split('*')[0] ?? 'NA',
    // totalAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.amount) ?? 0}`,
    refundAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.get('refundAmount')) ?? 0}`,
    refundRequestDate: item?.get('refundRequestedDate'),
    refundStatus: getStatusFromMap(item?.get('refundStatus')),
    transactionId: item?.get('transactionId'),
    // refundStatus: getRefundStatusMapping(item?.refund?.status),
  }))
}

const refundTableParser = (data: any) => {
  return data.map((item: any) => ({
    id: item?.get('originalTransactionId') ?? 'NA',
    ERN: item?.get('invoice') ?? 'NA',
    channel: item?.get('channel') ?? 'MANUAL',
    RRN: item?.get('transactionId') ?? '',
    bankRefNo: item?.get('bankReferenceNumber') ?? '',
    paymentMode: item?.get('cardType') ?? '',
    paymentType: item?.get('paymentType') ?? '',
    date: item?.get('transactionDateTime')?.split('*')[0] ?? 'NA', //Spliting as storing both formats needed for UI with index 0 and for API at index 1
    refundAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.get('refundAmount')) ?? 0}`,
    refundStatus: getStatusFromMap(item?.get('refundStatus')),
  }))
}

const refundConfirmTableParser = (data: any) => {
  return data.map((item: any) => ({
    id: item?.id ?? '',
    rrn: item?.rrn ?? '',
    amount: `${'\u20B9'}${' '}${numberToLocalString(item?.amount) ?? 0}`,
    refundAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.refund?.amount) ?? 0}`,
    transactionStatus: item?.refund?.status,
    message: item?.refund?.refundMessage,
  }))
}

const refundInitiateTableParser = (item: any) => {
  const retData: any = {
    id: item?.id ?? '',
    rrn: item?.rrn ?? '',
    date: item?.date?.split('*')[1] ?? '', //Spliting as storing both formats needed for UI with index 0 and for API at index 1
    paymentMode: item?.payment?.paymentMode ?? '',
    amount: `${'\u20B9'}${' '}${numberToLocalString(item?.amount) ?? 0}`,
    grossAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.convenienceFee?.originalTxnAmt) ?? 0}`,
    refundAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.refund?.amount) ?? 0}`,
    refundProcess: item?.refund?.processed,
  }
  if (item?.payment?.paymentMode === 'Sodexo') {
    retData.refundInvoiceId = item?.refund?.invoiceId
  }

  return retData
}

const refundSubscriptionInitiateTableParser = (data: any, selectedRRN: string) => {
  const refundItem: any[] = []
  data.map((item: any) => {
    const txn = item
    item.transactionsHistory.map((transactionsHistory: any) => {
      transactionsHistory.paymentHistory.map((paymentHistory: any) => {
        if (selectedRRN === paymentHistory?.transactionId) {
          const refI = {
            id: paymentHistory?.paymentId ?? '',
            rrn: paymentHistory?.transactionId ?? '',
            date: dateFormatter(transactionsHistory?.transactionDate, DateFormatTypes.MONTH_STRING) ?? '',
            amount: `${'\u20B9'}${' '}${paymentHistory?.amount ? numberToLocalString(paymentHistory?.amount) : 0}`,
            refundAmount: `${'\u20B9'}${' '}${
              paymentHistory?.refund ? numberToLocalString(paymentHistory?.refund) : 0
            }`,
            refundProcess: paymentHistory?.processed ?? 0,
          }
          refundItem.push(refI)
        }
      })
    })
    return txn
  })
  return refundItem
}

const refundStatusParser = (data: any) => {
  return data.map((item: any) => ({
    id: item?.id ?? '',
    rrn: item?.rrn ?? '',
    date: item?.date?.split('*')[1] ?? '', //Spliting as stored both formats needed for UI and for API
    paymentMode: item?.payment?.paymentMode ?? '',
    amount: `${'\u20B9'}${' '}${numberToLocalString(item?.amount) ?? 0}`,
    grossAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.convenienceFee?.originalTxnAmt) ?? 0}`,
    refundAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.refund?.processed) ?? 0}`,
    refundStatus: item?.refund?.status ?? 'Failed',
  }))
}

const refundSubscriptionStatusParser = (data: any, selectedRRN: string) => {
  const refundItem: any[] = []
  data.map((item: any) => {
    const txn = item
    item.transactionsHistory.map((transactionsHistory: any) => {
      transactionsHistory.paymentHistory.map((paymentHistory: any) => {
        if (selectedRRN === paymentHistory?.transactionId) {
          const refI = {
            id: paymentHistory?.paymentId ?? '',
            rrn: paymentHistory?.transactionId ?? '',
            date: dateFormatter(transactionsHistory?.transactionDate, DateFormatTypes.MONTH_STRING) ?? '',
            amount: `${'\u20B9'}${' '}${numberToLocalString(paymentHistory?.amount) ?? 0}`,
            refundAmount: `${'\u20B9'}${' '}${paymentHistory?.refundAmount}`, // `${'\u20B9'}${' '}${numberToLocalString(paymentHistory?.refund) ?? 0}`,
            refundStatus: paymentHistory?.refundStatus ?? 'FAILED',
            sourceSystem: paymentHistory?.sourceSystem ?? '',
          }
          refundItem.push(refI)
        }
      })
    })

    return txn
  })
  return refundItem
}

const settlementTableParser = (data: any, canExportSettlement: boolean) => {
  return data.map((item: any) => ({
    id: item?.id,

    fromDateOrg: item?.fromDate,
    fromDate: dateFormatter(item?.fromDate, DateFormatTypes.DATE_ONLY),
    toDate: dateFormatter(item?.toDate, DateFormatTypes.DATE_ONLY),
    toDateOrg: item?.toDate, // dateFormatter(item?.toDate, DateFormatTypes.DATE_ONLY),
    referenceNumber: item?.referenceNumber,
    settledTransactionCount: item?.settledTransactionCount,
    settledAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.settledAmount) ?? 0}`,
    refundCount: item?.refundCount,
    refundAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.refundAmount) ?? 0}`,
    settlementAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.settlementAmount) ?? 0}`,
    action: canExportSettlement ? 'EXPORT,DELETE' : 'N/A',
    loading: item?.loading,
    fileName: item?.fileName ?? 'NA',
  }))
}

const settlementMobileTableParser = (data: any) => {
  return data.map((item: any) => ({
    id: item?.id,
    date: item?.date,
    referenceNumber: item?.referenceNumber ?? 'NA',
    settledTransactionCount: item?.settledTransactionCount ?? 0,
    settledAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.settlementAmount) ?? 0}`,
    refundCount: item?.refundCount ?? 0,
    refundAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.refundAmount) ?? 0}`,
    settlementAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.settlementAmount) ?? 0}`,
    timestamp: getDateTimeStampInMillis(item?.date),
  }))
}

const settlementRecentsTableParser = (data: any) => {
  return data.map((item: any) => ({
    id: item?.id,
    // date: item?.date ?? '',

    fromDate: `${dateFormatter(item?.fromDate ?? '', DateFormatTypes.DATE_ONLY)}`,
    toDate: `${dateFormatter(item?.toDate ?? '', DateFormatTypes.DATE_ONLY)}`,
    settledTransactionCount: item?.settledTransactionCount,
    settledAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.settledAmount) ?? 0}`,
    file: item?.fileName ?? 'NA',
    referenceNumber: item?.referenceNumber,
  }))
}

const getBulkRefundStatus = (status: string) => {
  const getStatus: any = {
    INITIATED: 'INITIATED',
    CONFIRMED: 'IN_PROCESS',
    SPLITTING: 'IN_PROCESS',
    SPLIT_COMPLETE: 'IN_PROCESS',
    BATCH_COMPLETE: 'IN_PROCESS',
    REPORT_COMPLETE: 'SUCCESS',
    COMPLETE: 'IN_PROCESS',
    FAILED: 'FAILED',
  }
  return getStatus[status]
}

const bulkSummaryTableParse = (data: any) => {
  return data.map((item: any, index: number) => ({
    id: item?.id ?? index,
    fileName: item?.fileName ?? '',
    createdAt: item?.createdAt ?? '',
    count: item?.count ?? '',
    // totalRefundAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.totalRefundAmount) ?? ''}`,
    accepted: item?.accepted ?? '',
    // successAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.successAmount) ?? 0}`,
    declined: item?.declined ?? '',
    // failureAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.failureAmount) ?? 0}`,
    status: getBulkRefundStatus(item?.status),
    actionDownload: getBulkRefundStatus(item?.status) === 'SUCCESS' ? 'Download' : ' Download', //FIXME: hack to have download disabled on tableItem with extra space prefixed
  }))
}

const refundHistoryParser = (data: any) => {
  const history = data?.refundHistory?.map((item: any) => ({
    rrn: item?.rrn,
    transactionAmount: `${'\u20B9'}${' '}${numberToLocalString(data?.amount) ?? 0}`,
    refundAmount: `${'\u20B9'}${' '}${numberToLocalString(item?.refundAmount) ?? 0}`,
    refundInitiatedDate: item?.initiatedDate,
    refundStatus: item?.status,
    //refundDate: item?.processedOn,
    arn: item?.arn,
  }))

  return history
}

const refundViewParser = (data: any) => {
  return {
    refundAmount: data?.refund?.amount ?? 'NA',
    pendingAmount: data?.refund?.pending ?? 'NA',
    settlementDate: data?.settlementDetails?.date ?? 'NA',
    settlementFilename: data?.settlementDetails?.fileName ?? 'NA',
    neftNumber: data?.settlementDetails?.neftNumber ?? 'NA',
  }
}

const paymentLinksTableParser = (data: any) => {
  return data.map((item: any) => ({
    jioLinkId: item?.jioLinkId ?? '',
    createdAt: dateFormatter(item?.createdAt ?? 'NA', DateFormatTypes.DD_MMM_YYYY_FROM_YYYYMMDD),
    amount: `${'\u20B9'}${' '}${numberToLocalString(item?.amount) ?? 0}`,
    invoice: item?.invoice ?? '',
    pushSmsTo: item?.pushSmsTo ?? '',
    url: item?.url ?? '',
    status: item?.status ?? '',
  }))
}

const paymentLinkDetailsParser = (data: any, duplicate: boolean) => {
  return {
    amount: `₹ ${data?.amount}`,
    status: data?.status,
    transactions: data?.transactions,
    description: data?.description,
    pushSmsTo: data?.pushSmsTo,
    pushEmailTo: data?.pushEmailTo,
    createdAt: NewDateFormatter(data?.createdAt ?? 'NA', NewDateFormatterType.DD_MMM_YYYY_HH_MM_AMPM),
    linkExpiryAt: data?.linkExpiryAt,
    invoice: duplicate ? '' : data?.invoice,
    merchantLinkId: data?.merchantLinkId,
    url: data?.url,
    paidAt: data?.paidAt,
  }
}

const initRefundsTableParser = (data: any) => {
  const body = data.map((item: any) => ({
    check: 'check',
    id: item?.get('transactionId') ?? '',
    date: item?.get('transactionDateTime') ?? ''?.split('*')[0] ?? '',
    ERN: item?.get('invoice') ?? '',
    refundInvoiceId: item?.get('invoice') ?? '',
    rrn: item?.get('transactionId') ?? '',
    amount: `${'\u20B9'}${' '}${numberToLocalString(item?.get('transactionAmount')) ?? 0}`,
    transactionStatus: item?.get('transactionDisposition'),
    paymentMode: item?.get('cardType'),
    paymentType: item?.get('paymentType'),
    refundAmount: `${'\u20B9'}${' '}${item?.get('refundAmount') ?? 0}`,
  }))

  return [{}, ...body]
}
export {
  bulkSummaryTableParse,
  initRefundsTableParser,
  paymentLinkDetailsParser,
  paymentLinksTableParser,
  refundConfirmTableParser,
  refundHistoryParser,
  refundInitiateTableParser,
  refundMobileTableParser,
  refundsRecentsTableParser,
  refundStatusParser,
  refundSubscriptionInitiateTableParser,
  refundSubscriptionStatusParser,
  refundTableParser,
  refundViewParser,
  settlementMobileTableParser,
  settlementRecentsTableParser,
  settlementTableParser,
  subscriptionfilterTableParserData,
  transactionFilterMobileTableParser,
  transactionFilterTableParser,
  transactionRecentsTableParse,
}
